import { Tooltip } from "@mui/material";
import EAIcon from "components/common/EAIcon";
import parse from 'html-react-parser';
import { theme } from "style/globalStyle";

const TopicExamplesTooltip = ({title, content}) => {
    return(
        <Tooltip title={
            <>
                <div style={{ fontSize: "12px", fontWeight: "600"}}>{title}</div>
                <div style={{backgroundColor: "#FFF", borderRadius: "2px", color: theme.palette.black.dark}}>
                    <ul>
                        {parse(content)}
                    </ul>
                </div>
            </>
        } placement="top" arrow>
            <span style={{marginLeft: "2px", verticalAlign: "middle"}}><EAIcon icon="info-rounded" /></span>
        </Tooltip>
    )
}
export default TopicExamplesTooltip;